"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgReveal = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_REVEAL", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M11.023 8c0 1.657-1.353 3-3.023 3-1.67 0-3.023-1.343-3.023-3S6.33 5 8 5c1.67 0 3.023 1.343 3.023 3ZM9.008 8c0-.552-.451-1-1.008-1-.557 0-1.008.448-1.008 1S7.443 9 8 9c.557 0 1.008-.448 1.008-1Z" }),
    React.createElement("path", { d: "M8 1c4.111 0 7.504 3.054 8 7-.496 3.946-3.889 7-8 7-4.111 0-7.504-3.054-8-7 .496-3.946 3.889-7 8-7Zm0 12c2.995 0 5.485-2.163 5.963-5C13.486 5.163 10.996 3 8 3S2.515 5.163 2.037 8c.478 2.837 2.967 5 5.963 5Z" }))); };
exports.default = SvgReveal;
